import React from 'react';
import { useTranslation } from 'react-i18next';

import useArticles from '../../../Data/Article/useArticles';
import ListSection from '../../../components/list-section/list-section';
import OverflowGrid from '../../../components/overflow-grid';
import { getMarket } from '../../../i18n';
import { resolveArticlesRoute } from '../../utils';
import ArticleGridCard from './Components/ArticleGridCard';
import { getTestDriveArticleURLSearchParams } from './utils';

interface TestDriveArticlesProps {
  track: (event: string, data: any) => void;
}

const TestDriveArticles = ({ track }: TestDriveArticlesProps) => {
  const { t } = useTranslation('startpage');
  const market = getMarket();
  const [result] = useArticles(getTestDriveArticleURLSearchParams(market.marketCode));

  const articles = result?.response.documentList.documents;

  if (!articles) {
    return null;
  }

  return (
    <section className="page-section" aria-label={t('Brand test drives', { ns: 'startpage' })}>
      <ListSection
        title={t('Brand test drives', { ns: 'startpage' })}
        text={t('You will find more test drives here', { ns: 'startpage' })}
        link={`/${resolveArticlesRoute()}/valja-bil`}
        linkText={t('Show more test drives', { ns: 'startpage' })}
      >
        <OverflowGrid visibleItems={2}>
          {articles?.map((article) => (
            <ArticleGridCard article={article} track={track} key={article.id} />
          ))}
        </OverflowGrid>
      </ListSection>
    </section>
  );
};

export default TestDriveArticles;
